// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__tZ3A2","errors":"Errors_errors__3HLFV"};